// extracted by mini-css-extract-plugin
export var quantityInput = "_mc-0";